
<script>

  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  import _ from "lodash";

  import { supabase } from "../../libs/supabaseClient";

  import _system from '../../libs/system';
  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

  const audience = [{
   name: 'Andy Rhode',
   username: 'andy__23',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'andyrhode@gmail.com',
   phone: '+2671777319',
   platform: 'Facebook',
   id: '73216386125',
   messageCount: '234'
  },
  {
   name: 'Erdi Balcioglu',
   username: 'nicetrr',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'erdi@juphy.com',
   phone: '+15032908170',
   platform: 'Twitter',
   id: '3211456',
   messageCount: '967'
  },
  {
   name: 'Rui Costa',
   username: 'ruicossta',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'ruicosta@evagon.com',
   phone: '+5061772466612',
   platform: 'Facebook',
   id: '0093286125',
   messageCount: '124'
  },
  {
   name: 'Anne Fisherman',
   username: 'annblackcat',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: '-',
   phone: '+3165674536',
   platform: 'Instagram',
   id: '9908876362',
   messageCount: '7'
  },
  {
   name: 'Nitin guoda',
   username: 'nnitin7',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'nitingueda@gregorian.com',
   phone: '-',
   platform: 'Facebook',
   id: '27716386125',
   messageCount: '98'
  },
  {
   name: 'Adam',
   username: 'adamgoodman',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'adamgoodarman@coolermax.com',
   phone: '+90589433213',
   platform: 'Twitter',
   id: '00126386125',
   messageCount: '21'
  },
  {
   name: 'Rose Bree Salmon',
   username: 'rbs_78',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: '-',
   phone: '+5036798756',
   platform: 'Facebook',
   id: '100016387125',
   messageCount: '12'
  },
  {
   name: 'Adohaman',
   username: 'adohamaan',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: '-',
   phone: '-',
   platform: 'youtube',
   id: '73216386125',
   messageCount: '2'
  },
  {
   name: 'Brianna k.',
   username: 'brianna_',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'brianna@upserra.com',
   phone: '+3163458695',
   platform: 'Instagram',
   id: '00396386125',
   messageCount: '34'
  },
  {
   name: 'Alice Altman',
   username: 'alicealtmanss',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'alicealtmanss@gmail.com',
   phone: '-',
   platform: 'Twitter',
   id: '10000634345',
   messageCount: '234'
  },
  {
   name: 'Brian Swift',
   username: 'swftbrian',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'sbrian91@gmail.com',
   phone: '-',
   platform: 'Facebook',
   id: '9938871635',
   messageCount: '17'
  },
  {
   name: 'Eddy Portland',
   username: 'eddygunnerman',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'eddygunnerman@gmail.com',
   phone: '+5032908575',
   platform: 'Instagram',
   id: '10016333125',
   messageCount: '8'
  },
  {
   name: 'Xaan Yunnan',
   username: 'xxyhan_ch',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'xxyhchan@baidu.com',
   phone: '-',
   platform: 'Twitter',
   id: '44000386125',
   messageCount: '76'
  },
  {
   name: 'Cem Stemati',
   username: 'cem__st',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'cemstamati89@gmail.com',
   phone: '+15038909273',
   platform: 'Facebook',
   id: '200000386125',
   messageCount: '78'
  },
  {
   name: 'John',
   username: 'jhon_98',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: '-',
   phone: '-',
   platform: 'Facebook',
   id: '700216377125',
   messageCount: '12'
  },
  {
   name: 'Xavi Fernandez',
   username: 'xavif_',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'xavi@groovea.com',
   phone: '+15032113837',
   platform: 'Instagram',
   id: '1000216388825',
   messageCount: '43'
  },
  {
   name: 'Tiffany',
   username: 'tiff_vancouver',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'tiff@vancouvercounty.com',
   phone: '+15032678838',
   platform: 'Twitter',
   id: '10002735541',
   messageCount: '32'
  },
  {
   name: 'Gladys Moore',
   username: 'gladys_papa',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'gladys@papamurphy.com',
   phone: '+13603457687',
   platform: 'Instagram',
   id: '73216386125',
   messageCount: '28'
  },
  {
   name: 'Courtney Gox',
   username: 'courtnyvan',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'courtney@papamurphy.com',
   phone: '+13609876765',
   platform: 'Instagram',
   id: '400029826',
   messageCount: '34'
  },
  {
   name: 'Allen Rose',
   username: 'allenroose',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'allenrose983@gmail.com',
   phone: '-',
   platform: 'Facebook',
   id: '5003917761',
   messageCount: '72'
  },
  {
   name: 'Erick',
   username: 'erick881_',
   avatar: 'https://semantic-ui.com/images/avatar2/small/lena.png',
   email: 'erick@goodreadz.com',
   phone: '-',
   platform: 'Facebook',
   id: '500399816',
   messageCount: '112'
  }
  ]

export default {
   name: "audience",
   data() {
      return {
         audience,
         searchQuery: '',
         modals: {
            upload: false,
            details: false
         }
      }
   },
   computed: {
      filteredContacts: function () {
            var self = this;
            return this.contacts.filter(function (contact) {
                return contact.name.toLowerCase().indexOf(self.searchQuery.toLowerCase()) >= 0
                 || contact.email.toLowerCase().indexOf(self.searchQuery.toLowerCase()) >= 0;
            });
        },
   ...mapGetters('session', ['isLoggedIn', 'getUser', 'getWhiteLabel']),
   ...mapGetters("workspaces", ["workspaces", "currentWorkspace", "workspacesByUser"]),
   ...mapGetters('contacts', ['contacts']),
   },
   methods: {
   ...mapActions("session", ["setUser"]),
   ...mapActions("contacts", ["setContacts"]),
   ...mapActions("htmlModals", ["setEditUser"]),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
   contactDetails(){
         this.modals.details = true;
      },
   uploadCsv(){

    var fileInput = document.getElementById('file-input');
    var file = fileInput.files[0];

    if (!file) {
        alert('Please select a file to upload');
        return;
    }

    var reader = new FileReader();
    reader.onload = (event) => {
        var csvData = event.target.result;

        // Split CSV into rows
        var rows = csvData.split('\n');
        // Check if header row contains expected columns
        var header = rows[0];
        console.log(header)
        if (!header.includes('phone')) {
            alert('The selected file does not contain the expected columns');
            return;
        }

        // Step 1: Parse the CSV string into an array of objects
        const currentdata = csvData.split('\n').map(line => {
          const [id, name, email, phone] = line.split(',');
          return { id, name, email, phone };
        });

        // Step 2: Create a new array of objects with the phone property removed
        const newData = currentdata.map(({ name, email, phone }) => ({ name, email, phone }));

        let readyToInsertData = newData.slice(1);

          readyToInsertData = readyToInsertData.map((row) => {
            row.ws_id = this.currentWorkspace._id
            return row;
          })

        supabase.from('contacts').upsert(readyToInsertData, {
            onConflict: 'email, phone',
            set: {
              phone: 'excluded.phone',
              name: 'excluded.name'
            },
          }).then(result => {
            this.setContacts(readyToInsertData)
            // Handle successful insertion
               this.modals.upload = false;
               iziToast.success({
                  position: 'bottomCenter',
                  title:  readyToInsertData.length +' contacts successfully updated.'
               });
          })
          .catch(error => {
            // Handle insertion error
            console.error(error)
          });

        // Step 3: Convert the array of objects back into a CSV string
        //csvData = newData.map(({ name, email, phone }) => [name, email, phone].join(',')).join('\n');

/*         rows = csvData.split('\n');
        // Convert CSV to array of objects
        var data = [];
        
				for (var i = 0; i < rows.length; i++) {
					data.push(rows[i].split(','));
				}

				// Create HTML table
				var table = document.getElementById('csv-table');
				table.innerHTML = '';
				for (var i = 0; i < data.length; i++) {
					var row = document.createElement('tr');
					for (var j = 0; j < data[i].length; j++) {
						var cell = document.createElement('td');
						cell.appendChild(document.createTextNode(data[i][j]));
						row.appendChild(cell);
					}
					table.appendChild(row);
				} */


    };
    reader.readAsText(file);
   }
   },
   mounted(){

      if(!localStorage.getItem("juphy_onboarding_contact")){
         window.Intercom("showArticle", 7876963);
         localStorage.setItem("juphy_onboarding_contact", "true");
      }


      //const { data, error } = this.supabase.query('SELECT * FROM contacts');

      supabase.from('contacts').select('*').eq('ws_id', this.currentWorkspace._id).then(result => {
            this.setContacts(result)
            // Handle successful insertion
            this.setContacts(result.data)
            console.log(result)
          })
          .catch(error => {
            // Handle insertion error
            console.error(error)
          });

   }
}

</script>

<template>


   <div class="ui grid">
      <div class="sixteen wide column centered">

<div v-if="modals.upload " class="modalWrapper">
<div @click="modals.upload = false" class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">
      <div  class="ui grid centered stackable">
        <div style="padding-top:0; padding-bottom:0; padding-right:0;" class="six wide column" >
          <div  @click="modals.upload = false"  class="ui basic segment right aligned">
            <a style="background: rgba(0,0,0,0.6); position:relative; z-index:999999" class="ui black mini button">Close [ESC]</a>
          </div>
        </div>
      </div>
  <div class="ui grid centered stackable">
        <div style="background: rgba(0,0,0,.06);z-index: 9999;border-radius: 10px;" class="six wide column">
        <div class="ui grid">
        <div style="padding-bottom: 0;" class="row">
          <div class="sixteen wide column">
            <div style="background: #f5f5f5; border-bottom: 1px solid #e9e9e9; border-radius: 3px 3px 0 0;" class="ui basic segment">
               <div class="ui warning message">
            <i class="icon help"></i>
            Your .CSV file must have <b>name, email and phone</b> columns. Otherwise, upload may not be completed properly.
            </div>
            <p> <b>Please select a .CSV file and click upload.</b> </p>

            <input type="file" id="file-input">
            <div class="ui hidden divider"></div>
	         <button @click="uploadCsv()" class="ui fluid blue button" type="button" >Upload</button>

            </div>
          </div>
        </div>
        </div>
        </div>
    </div>
    </div>
    </div>


<div v-if="modals.details " class="modalWrapper">
<div @click="modals.details = false" class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">
      <div  class="ui grid centered stackable">
        <div style="padding-top:0; padding-bottom:0; padding-right:0;" class="eight wide column" >
          <div  @click="modals.details = false"  class="ui basic segment right aligned">
            <a style="background: rgba(0,0,0,0.6); position:relative; z-index:999999" class="ui black mini button">Close [ESC]</a>
          </div>
        </div>
      </div>
  <div class="ui grid centered stackable">
        <div style="background: rgba(18, 18, 18, 0.56);z-index: 9999;border-radius: 10px;" class="eight wide column">
         <div  class="ui stackable equal width grid">
            <div class="column">
      <div class="reportCard orangelish">
        <div style="display: inline-block;">
        <span style="font-size: 30px">0</span> 
          <p>Cart</p>
        </div>
        <i style="float: right;" class="cart large icon"></i>
      </div>
    </div>
        <div class="column">
      <div class="reportCard greenlish">
        <div style="display: inline-block;">
        <span style="font-size: 30px">0</span> 
          <p>Purchased</p>
        </div>
        <i style="float: right;" class="dollar sign large icon"></i>
      </div>
    </div>
  </div>

        <div class="ui grid">
          <div class="sixteen wide column">
            <div style="background: #222;  border-radius: 3px 3px 0 0;" class="ui basic segment">
               <table class="ui celled inverted table">
            <thead>
               <tr>
                  <th>Browsing history</th>
                  <th>CreatedAt</th>
               </tr>
            </thead>
            <tbody>
               <tr>
                  <td>-</td>
                  <td>-</td>
               </tr>
            </tbody>
            </table>

            </div>
          </div>

        </div>
        </div>
    </div>
    </div>
    </div>

         <div style=" background: #f1f1f1; margin: -1rem -1rem 1rem -1rem;" class="ui grid">
         <div class="four wide column">
            <div @click="modals.upload = true" class="ui teal button float left">Import Contacts</div>
         </div>
         <div class="twelve wide column right aligned">
            <div class="ui input">
               <input v-model="searchQuery" type="text" placeholder="Search...">
            </div>
         </div>
         </div>

         <table v-if="contacts.length" class="ui celled table">
         <thead>
            <tr>
               <th>Name</th>
               <th>Email</th>
               <th>Phone</th>
               <th></th>
            </tr>
         </thead>
         <tbody>
            <tr v-for="(contact, i) in filteredContacts" :key="contact.email">
               <td data-label="Name">
                  <h4 class="ui image header">
                     <img :src="'https://picsum.photos/id/' +(i+50)+ '/200'" class="ui mini rounded image">
                     <div class="content">
                        {{contact.name}}
                        <div class="sub header">
                           <!-- {{au.username}} -->
                     </div>
                  </div>
                  </h4>
               </td>
               <td data-label="email">{{contact.email}}</td>
               <td data-label="Phone">{{contact.phone}}</td>
<!--                <td data-label="Platform">
                  <img style="width: 25px; height: 25px; border-radius: 25px; margin-right: 6px;" :src="'/img/socialSvg/'+ au.platform.toLowerCase() +'.svg'" alt="">
                  </td>
               <td data-label="Social ID">{{au.id}}</td>
               <td data-label="# Messages">{{au.messageCount}}</td> -->
               <td>
                  <div @click="contactDetails()" class="ui fluid button"> <b>View Details</b> </div>
               </td>
            </tr>
         </tbody>
         </table>
      </div>
   </div>


</template>


<style scoped>

.reportCard{
    padding: 1rem;
    border-radius: 5px;
    color: rgba(255,255,255, 0.9);
  }

  .yellowLish{
background-image: radial-gradient( circle farthest-corner at 46.6% 51.1%,  rgba(255,146,139,1) 0%, rgba(255,172,129,1) 90% );
  }
  .blueLish{
background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(75,108,183,1) 0%, rgba(55,82,141,1) 90% );
  }
  .greenLish{
background-image: radial-gradient( circle 347px at -1.2% 12%, rgb(44, 184, 168) 0%, rgb(240, 230, 142) 50% );
  }
  .geclish{
background-image: radial-gradient( circle 1027px at -1.2% 102%, #37528d 0%, #a16eed 30% )
  }
  .purpLish{
    background-image: linear-gradient( 109.6deg,  rgba(119,44,232,0.68) 11.5%, rgba(119,44,232,1) 91.2% );
  }
  .orangeLish{
    background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(255,122,78,1) 0%, rgba(255,205,112,1) 90% );
  }

.front{
  box-shadow: rgb(224, 224, 224) 0px 2px 4px !important;
  border-radius: 5px !important;
  background: #ffffff !important;
}

.active{
   font-weight:bold !important;
}
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.65) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 2px 54px rgba(99, 99, 99, 0.85);
   border: none;
   background: #eee;
}
</style>





// WEBPACK FOOTER //
// src/components/dashboard/Audience.vue